import { supabase } from "@/lib/supabase";
import { 
  USERS_META_TABLE_NAME
} from "@/store/const";
import { throwOnSupabaseError } from "@/utils/errors";
import { transformSupabaseDates } from "@/utils/transformers";



export type UpdateSelectedBrandIdArgs = {
    userID: string;
    brandId: number;
};


export const usersMetaApi = {
    fetchUsersMeta: async (userId: string) => {
        const { data, error } = await supabase
            .from(USERS_META_TABLE_NAME)
            .select("*")
            .eq("user_id", userId)
            .single();

        throwOnSupabaseError(error);

        return transformSupabaseDates(data);
    },
    updateSelectedBrandId: async (args: UpdateSelectedBrandIdArgs ) => {
        const { data, error } = await supabase
            .from(USERS_META_TABLE_NAME)
            .update({ selected_brand_id: args.brandId })
            .eq("user_id", args.userID);
    
        throwOnSupabaseError(error);

        return transformSupabaseDates(data);
    },
}